import { render, staticRenderFns } from "./ActivityModal.vue?vue&type=template&id=5604edb8&"
import script from "./ActivityModal.vue?vue&type=script&lang=js&"
export * from "./ActivityModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5604edb8')) {
      api.createRecord('5604edb8', component.options)
    } else {
      api.reload('5604edb8', component.options)
    }
    module.hot.accept("./ActivityModal.vue?vue&type=template&id=5604edb8&", function () {
      api.rerender('5604edb8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/chooseSeat/ActivityManage/modules/ActivityModal.vue"
export default component.exports